export default __webpack_public_path__ + "static/media/facebook_ads.e4be2864.svg";